/**
 * Lista simplificada de partes do corpo humano que podem ser atingidas em acidentes
 * Baseado em normas de segurança e classificação de riscos
 */
export const PARTES_CORPO_ATINGIDAS = [
  'Corpo inteiro',
  'Cabeça',
  'Pescoço',
  'Tórax',
  'Membros superiores',
  'Membros inferiores',
  'Mãos',
  'Pés',
  'Olhos',
  'Face',
] as const;

export type ParteCorpoAtingida = typeof PARTES_CORPO_ATINGIDAS[number];

/** Assinatura mínima do `t` do `useI18n()` — a constante não importa React. */
type Traduzir = (chave: string) => string;

const RAIZ = 'apreciacaoTabelas.partesCorpo';

/**
 * O texto em português é o valor gravado na apreciação; o mapa abaixo só diz
 * onde mora a tradução de cada um.
 */
export const CHAVE_PARTE_CORPO: Record<string, string> = {
  'Corpo inteiro': 'corpoInteiro',
  'Cabeça': 'cabeca',
  'Pescoço': 'pescoco',
  'Tórax': 'torax',
  'Membros superiores': 'membrosSuperiores',
  'Membros inferiores': 'membrosInferiores',
  'Mãos': 'maos',
  'Pés': 'pes',
  'Olhos': 'olhos',
  'Face': 'face',
};

/** Parte fora da lista (digitada à mão em apreciação antiga) sai como está. */
export function traduzirParteCorpo(t: Traduzir, parte: string): string {
  const chave = CHAVE_PARTE_CORPO[parte];
  return chave ? t(`${RAIZ}.${chave}`) : parte;
}
